// extracted by mini-css-extract-plugin
export default {"container":"contact_container__qlB4a","item":"contact_item__OwuHa","img":"contact_img__7IARw","text":"contact_text__Ec3WZ"};